import { Kns } from '../types';
import { CommonApi, CommonApiMethod } from '.';
const route = 'kns';
const kns: CommonApiMethod = new CommonApi<Kns>(route, 'КНС');

export default kns;
